module.exports = "/_next/static/images/rappler-article-68c531e8c751051f485298922df1bebc.png";